import ULPSPortalApiClient from "./UlpsPortalApiClient";

class Store {
  #token = null;
  #tokenExp = null;

  get token() {
    return this.#token;
  }

  set token(token) {
    this.#token = token;
    ULPSPortalApiClient.updateAuthHeader();
  }

  set tokenExp(value) {
    this.#tokenExp = value ? Number(value) : null;
  }

  get tokenExp() {
    return this.#tokenExp;
  }

  isTokenExpired() {
    return !this.#tokenExp || Date.now() >= this.#tokenExp;
  }
}

const store = new Store();
export default store;

